/**
 * React 19 compatibility shim for USBInput.
 *
 * @usb-shield/components-react uses defaultProps to set offScreenHelperText to ''
 * on USBInput. React 19 removed defaultProps support for function components, so
 * offScreenHelperText arrives as undefined and the internal bundle call to
 * offScreenHelperText.length crashes. This wrapper supplies the missing default.
 */
import React from 'react';
import { USBInput as USBInputBase } from '@usb-shield/components-react/dist/cjs';

const USBInput = ({ offScreenHelperText = '', ...props }) => (
  <USBInputBase offScreenHelperText={offScreenHelperText} {...props} />
);

export { USBInput };
export default USBInput;
